<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()" />

      <div class="modal__dialog">
        <header class="modal__header">
          <slot name="header" />
        </header>

        <main class="modal__body">
          <slot name="body" />
          <div class="modal__body-copy" v-if="showPassword">
            <div
              class="modal__body-password"
              v-tippy="{
                content: tippyContent,
                hideOnClick: false,
                theme: 'material',
                animation: 'shift-away',
                onHidden(instance) {
                  tippyContent = 'Скопировать';
                },
              }"
              @click="copyPassword"
            >
              {{ userPassword }}
            </div>
          </div>
        </main>

        <footer class="modal__footer">
          <slot name="footer" />
          <button
            class="btn"
            @click="closeModal"
            :disabled="!isCopied && showPassword"
          >
            Закрыть
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
// https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
// https://medium.com/notonlycss/how-to-build-a-modal-in-vue-js-b3db644afaeb
import { directive } from 'vue-tippy';

export default {
  name: 'Modal',
  directives: {
    tippy: directive,
  },

  props: {
    backdropClick: {
      type: Boolean,
      default: true,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: this.isOpen,

      isCopied: false,
      userPassword: '',
      tippyContent: 'Скопировать',
    };
  },
  methods: {
    closeModal(e) {
      // this.$emit('close');

      if (!this.backdropClick && e === undefined) {
        return;
      } else {
        this.show = false;
        document.querySelector('body').removeAttribute('style');
      }
    },

    openModal() {
      this.show = true;
      document.querySelector('body').style.overflow = 'hidden';
    },

    async copyPassword() {
      try {
        navigator.clipboard.writeText(this.userPassword);
        console.log('copy');
        this.isCopied = true;
        this.tippyContent = 'Пароль скопирован';
      } catch (err) {
        console.log('error copy');
        this.isCopied = true;
        this.tippyContent = 'Ошибка копирования';
      }
    },
  },

  mounted() {
    // document.querySelector('body').style.overflow = 'hidden';

    if (this.$store.state.user?.password) {
      this.userPassword = this.$store.state.user.password;
      delete this.$store.state.user.password;

      this.openModal();
    }
  },
};
</script>


<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  align-items: center;
  &__backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
  &__dialog {
    position: relative;
    max-width: 500px;
    background-color: #ffffff;
    border-radius: 5px;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    z-index: 2;
    padding: 30px;
    gap: 20px;
    @media screen and (max-width: 992px) {
      width: 90%;
    }
  }
  &__close {
    width: 30px;
    height: 30px;
  }
  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 22px;
    color: #374d6e;
    font-weight: 600;
  }
  &__body {
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.8);
    gap: 5px;

    &-copy {
      display: flex;
      gap: 5px;
    }

    &-password {
      padding: 10px 20px;
      background: #e5e5e5;
      border-radius: 5px;
      width: 100%;
      cursor: pointer;
    }

    // ::v-deep p {
    //   color: red;
    // }
  }
  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    button {
      background: #05657c;
      color: white;
      border: none;
      border-radius: 5px;
      padding: 10px 15px;

      &:hover {
        box-shadow: none;
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
